import React from "react";
import MaterialIcon from "../MaterialIcon";
import "./chat-pro.css";

// "Translated from German · Show original" under a translated message (mobile:
// ProMessageRow.ProTranslationLine). While showing the original: "Original (German) ·
// Show translation"; while translating: "Translating…". The language is named in the UI language.

const displayNamesCache = new Map();

export function languageNameOf(code, uiLanguage) {
  if (!code) return "";
  const lang = String(code).toLowerCase().split(/[-_]/)[0];
  const ui = String(uiLanguage || "en").toLowerCase().split(/[-_]/)[0];
  try {
    if (typeof Intl === "undefined" || typeof Intl.DisplayNames !== "function") return "";
    if (!displayNamesCache.has(ui)) displayNamesCache.set(ui, new Intl.DisplayNames([ui], { type: "language" }));
    const name = displayNamesCache.get(ui).of(lang);
    if (!name || name.toLowerCase() === lang) return "";
    return name.charAt(0).toUpperCase() + name.slice(1);
  } catch (_) {
    return "";
  }
}

export default function TranslationLine({ translating, showingOriginal, langCode, uiLanguage, onToggle, labels = {} }) {
  const lang = languageNameOf(langCode, uiLanguage);
  let text;
  if (translating) text = labels.translating;
  else if (showingOriginal) text = lang ? `${labels.original} (${lang})` : labels.original;
  else text = lang ? `${labels.translatedFrom} ${lang}` : labels.translated;
  const canToggle = !translating && typeof onToggle === "function";
  return (
    <div className="kjc-trans">
      <MaterialIcon icon="translate" size={14} weight={400} />
      <span className="kjc-trans__text">{canToggle ? `${text} ·` : text}</span>
      {canToggle ? (
        <button
          type="button"
          className="kjc-trans__link"
          onClick={(e) => {
            e.stopPropagation();
            onToggle();
          }}
        >
          {showingOriginal ? labels.showTranslation : labels.showOriginal}
        </button>
      ) : null}
    </div>
  );
}
